import { BoxProps } from '@mui/material/Box';
//
import LoadingScreen from './loading-screen';

// ----------------------------------------------------------------------

type SplashScreenProps = BoxProps & {
  message?: string;
};

export default function SplashScreen({
  sx,
  message = 'Initialisation...',
  ...other
}: SplashScreenProps) {
  return (
    <LoadingScreen
      fullScreen
      message={message}
      sx={{
        height: 1,
        ...sx,
      }}
      {...other}
    />
  );
}
